import React from 'react';
import classnames from 'classnames';
import { DynamicMediaPicture, MultiDynamicMediaImageConfigs } from '../../dynamic-media-picture';
import { ImageType, LinkType } from '../../types';
import { Text } from '../../text';
import { Icon } from '../../icon';
import styles from './campaign-card.module.scss';

export type CampaignCardType = {
  link: LinkType;
  copyText: string;
  imageConfigs: MultiDynamicMediaImageConfigs;
  className?: string;
} & ImageType;

export const CampaignCard: React.FC<CampaignCardType> = ({
  link,
  copyText,
  imageUrl,
  imageAltText,
  hasImageTransparency,
  imageConfigs,
  className
}) => (
  <a
    href={link.href}
    className={classnames(styles.campaignCard, className)}
    target={link.target}
    rel={link.rel}
    onClick={link.onClick}
  >
    <span className={styles.text}>
      <Text tag="span" variant="label-100" withShadow={true} className={styles.label}>
        {link.label}
        {link.isExternal && <Icon className={styles.icon} name="external-link--small"></Icon>}
      </Text>
      <Text tag="span" variant="paragraph-200" withShadow={true} className={styles.copy}>
        {copyText}
      </Text>
    </span>
    <DynamicMediaPicture
      className={styles.image}
      imageAltText={imageAltText}
      hasImageTransparency={hasImageTransparency}
      imageUrl={imageUrl}
      imageConfigs={imageConfigs}
      hasDarkeningLayer
    ></DynamicMediaPicture>
  </a>
);
